export default "__VITE_ASSET__Cig$FZBd__"